import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';
import { QueryParamsEnum } from '@/interfaces/history.interfaces';

function useAppScroll() {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const scrollTo = searchParams.get(QueryParamsEnum.ScrollTo);

  const isPageReady = useAppSelector(rootSelectors.installation.pageReadySelector);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (isPageReady && scrollTo) {
      const element = document.querySelector(scrollTo);

      if (!element) {
        return;
      }

      setTimeout(() => {
        element.scrollIntoView({
          behavior: 'smooth',
        });
        setSearchParams(
          prev => {
            prev.delete(QueryParamsEnum.ScrollTo);
            return prev;
          },
          {
            replace: true,
          },
        );
      }, 100);
    }
  }, [isPageReady, scrollTo]);
}

export default useAppScroll;
